import { render, staticRenderFns } from "./communityContentPublishing.vue?vue&type=template&id=25430f99&scoped=true"
import script from "./communityContentPublishing.vue?vue&type=script&lang=js"
export * from "./communityContentPublishing.vue?vue&type=script&lang=js"
import style0 from "./communityContentPublishing.vue?vue&type=style&index=0&id=25430f99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25430f99",
  null
  
)

export default component.exports